<div class="booble-backdrop" *ngIf="boobleModalData">

  <div class=" xp-modal xp-modal-cadastro">
    <div class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm">
      <div class="modal-content">
        <div class="modal-header">

          <div>
            <div class="header-title">Conciliação da cotação</div>
            <p class="header-subtitle">Insira as informações abaixo para realizar a conciliação.</p>
          </div>
          <button type="button" (click)="goBack()" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="form tpl-form-2 pt-0 modal-dialog-scrollable-general">

            <form [formGroup]="orderForm">

              <div class="form-row">

                <!-- Detalhe da ordem -->

                <mat-accordion class="w-100">
                  <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <h5>
                          Informações da ordem</h5>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="detail-order w-100">
                      <div class="content-detail-order">
                        <div class="container-display">
                          <p title="{{ boobleModalData.id }}" class="text-value">
                            <strong class="text-name">Número: </strong>{{ boobleModalData.id }}
                          </p>
                          <p title="{{
                            boobleModalData.amount | currency: boobleModalData.currency.description
                            }}" class="text-value">
                            <strong class="text-name">Valor de origem: </strong>{{
                            boobleModalData.amount | currency: boobleModalData.currency.description
                            }}
                          </p>
                          <p title="{{ boobleModalData.finality.description }}" class="text-value">
                            <strong class="text-name">Finalidade: </strong>{{ boobleModalData.finality.description }}
                          </p>
                          <span class="text-value">
                            <strong class="text-name">Status: </strong>

                            <span title="Pendente documentação" *ngIf="
                                boobleModalData.statusFlow == 'PENDING_DOCUMENTATION'
                              ">Pendente documentação</span>
                            <span class="red"
                              *ngIf='boobleModalData.statusFlow == "REPROVED_WITH_CORRECTION" || boobleModalData.statusFlow == "REPROVED_WITHOUT_CORRECTION"'>
                              Reprovada</span>

                            <span title="Invoice pendente" *ngIf="
                                boobleModalData.statusFlow == 'PENDING_INVOICE_ATTACHMENT'
                              ">Invoice pendente</span>

                            <span title="Liquidada" *ngIf="
                            boobleModalData.statusFlow == 'PAID'">Liquidada</span>

                            <span title="Disponível para cotação" class="green" *ngIf="
                                boobleModalData.statusFlow == 'AVAILABLE_QUOTATION'
                              ">Disponível para cotação</span>

                            <span title="Cotada" class="green" *ngIf="
                                boobleModalData.statusFlow == 'AVAILABLE_PAYMENT'
                              ">Cotada</span>

                            <span title="Em processamento" *ngIf="boobleModalData.statusFlow == 'PROCESSING'">Em
                              processamento</span>
                            <span title="Invoice pendente" *ngIf="
                                boobleModalData.statusFlow ==
                                'PENDING_INVOICE_INFORMATION'
                              ">Invoice pendente</span>
                          </span>
                        </div>

                        <div class="container-display">
                          <p class="text-value">
                            <strong class="text-name">Data de criação: </strong>{{ boobleModalData.createdDate | date:
                            "dd/MM/yyyy"
                            }}
                          </p>
                          <p>
                            <span class="text-value">
                              <strong class="text-name">Moeda de origem: </strong>

                              <span title="Dólar (USD)" *ngIf='boobleModalData.currency.description == "USD"'>Dólar
                                (USD)</span>
                              <span title="Euro (EUR)" *ngIf='boobleModalData.currency.description == "EUR"'>Euro
                                (EUR)</span>
                              <span title="Libra esterlina (GBP)"
                                *ngIf='boobleModalData.currency.description == "GBP"'>Libra
                                esterlina (GBP)</span>
                              <span title="Dólar canadense (CAD)"
                                *ngIf='boobleModalData.currency.description == "CAD"'>Dólar
                                canadense (CAD)</span>
                              <span title="Franco suíço (CHF)"
                                *ngIf='boobleModalData.currency.description == "CHF"'>Franco suíço
                                (CHF)</span>

                            </span>
                          </p>
                          <p class="text-value">
                            <strong class="text-name">Tipo de ordem: </strong><span title="Recebimento (inbound)"
                              *ngIf="boobleModalData.remmitanceType == 'INBOUND'">
                              Recebimento (inbound)</span>
                            <span title="Envio (outbound)" *ngIf="boobleModalData.remmitanceType == 'OUTBOUND'">
                              Envio (outbound)</span>
                          </p>
                        </div>
                      </div>
                      <br />

                      <h5 style="margin-bottom: 35px">Dados do cliente</h5>

                      <div class="content-detail-order">
                        <div class="container-display">
                          <p title="{{ boobleModalData.corporateAccount.companyName }}" class="text-value">
                            <strong class="text-name">Nome: </strong>{{ boobleModalData.corporateAccount.companyName }}
                          </p>
                          <p title="{{ boobleModalData.corporateAccount.cnpj }}" class="text-value">
                            <strong class="text-name">CNPJ: </strong>{{
                            boobleModalData.corporateAccount.cnpj
                            | mask: "AA.AAA.AAA/AAAA-00"
                            }}
                          </p>
                          <ng-container *ngIf="boobleModalData.remmitanceType == 'INBOUND'">
                            <p title="{{ boobleModalData.sender.email }}" class="text-value">
                              <strong class="text-name">E-mail: </strong><span>
                                {{ boobleModalData.sender.email }}</span>
                            </p>
                          </ng-container>
                        </div>

                        <div class="container-display">
                          <p title="{{ boobleModalData.corporateAccount.cnpj }}" class="text-value">
                            <strong class="text-name">Matriz/Filial: </strong>{{
                            boobleModalData.corporateAccount.cnpj
                            | mask: "AA.AAA.AAA/AAAA-00"
                            }}
                          </p>

                        </div>
                      </div>
                      <br />

                      <h5 style="margin-bottom: 35px">Dados do pagador</h5>

                      <ng-container *ngIf="boobleModalData.remmitanceType == 'INBOUND'">
                        <div class="content-detail-order">
                          <div class="container-display">
                            <p title="{{ boobleModalData.sender.companyName }}" class="text-value">
                              <strong class="text-name">Nome: </strong>{{ boobleModalData.sender.companyName }}
                            </p>
                          </div>
                          <div class="container-display">
                            <p title="{{ boobleModalData.sender.country }}" class="text-value">
                              <strong class="text-name">País: </strong>{{ boobleModalData.sender.country }}
                            </p>
                          </div>
                        </div>
                      </ng-container>

                      <ng-container *ngIf="boobleModalData.remmitanceType == 'OUTBOUND'">
                        <div class="content-detail-order">
                          <div class="container-display">
                            <p title="{{ boobleModalData.corporateAccount.companyName }}" class="text-value">
                              <strong class="text-name">Nome: </strong>{{ boobleModalData.corporateAccount.companyName
                              }}
                            </p>
                            <p title="{{ boobleModalData.receiver.country }}" class="text-value">
                              <strong class="text-name">País: </strong>{{ boobleModalData.receiver.country }}
                            </p>
                          </div>

                          <div class="container-display">
                            <p title="{{ boobleModalData.corporateAccount.cnpj }}" class="text-value">
                              <strong class="text-name">CPF/CNPJ: </strong>{{
                              boobleModalData.corporateAccount.cnpj| mask: "AA.AAA.AAA/AAAA-00"
                              }}
                            </p>
                          </div>
                        </div>
                      </ng-container>

                    </div>
                  </mat-expansion-panel>
                </mat-accordion>


                <!-- Fim detalhe da ordem -->

                <div class="row pl-3 pr-3">
                  <div class="col-md-12">
                    <h5 style="margin-bottom: 15px; margin-top: 15px;">
                      Informações da cotação</h5>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="line">
                        <div class="label">Valor moeda estrangeira<span class="text-danger"> *</span></div>
                        <input formControlName="amountME" currencyMask
                          [options]="{ prefix: '', thousands: '.', decimal: ',' }"
                          (blur)="orderFormControl.amountME.value < 0 ? orderFormControl.amountME.setValue(0) : orderFormControl.amountME.value; orderFormControl.amountME.value >= 999999 ? orderFormControl.amountME.setValue(999999) : orderFormControl.amountME.value;"
                          type="text" class="form-control" name="" required />
                        <span class="text-danger"
                          *ngIf="(orderFormControl.amountME.touched) && orderFormControl.amountME.errors?.required">
                          Valor obrigatório
                        </span>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="line">
                        <div class="label">Valor moeda nacional<span class="text-danger"> *</span></div>
                        <input formControlName="amountMN" currencyMask
                          [options]="{ prefix: '', thousands: '.', decimal: ',' }"
                          (blur)="orderFormControl.amountMN.value < 0 ? orderFormControl.amountMN.setValue(0) : orderFormControl.amountMN.value; orderFormControl.amountMN.value >= 999999 ? orderFormControl.amountMN.setValue(999999) : orderFormControl.amountMN.value;"
                          type="text" class="form-control" name="" required />
                        <span class="text-danger"
                          *ngIf="(orderFormControl.amountMN.touched) && orderFormControl.amountMN.errors?.required">
                          Valor obrigatório
                        </span>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="line">
                        <div class="label">Valor efetivo total<span class="text-danger"> *</span></div>
                        <input formControlName="vet" currencyMask
                          [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                          (blur)="orderFormControl.vet.value < 0 ? orderFormControl.vet.setValue(0) : orderFormControl.vet.value; orderFormControl.vet.value >= 999999 ? orderFormControl.vet.setValue(999999) : orderFormControl.vet.value;"
                          type="text" class="form-control" name="" required />
                        <span class="text-danger"
                          *ngIf="(orderFormControl.vet.touched) && orderFormControl.vet.errors?.required">
                          Valor obrigatório
                        </span>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="line">
                        <div class="label">IOF<span class="text-danger"> *</span></div>
                        <input formControlName="iof" currencyMask
                          [options]="{ prefix: '', thousands: '.', decimal: ',', suffix: '%'  }"
                          (blur)="orderFormControl.iof.value < 0 ? orderFormControl.iof.setValue(0) : orderFormControl.iof.value; orderFormControl.iof.value >= 999999 ? orderFormControl.iof.setValue(999999) : orderFormControl.iof.value;"
                          type="text" class="form-control" name="" required />
                        <span class="text-danger"
                          *ngIf="(orderFormControl.iof.touched) && orderFormControl.iof.errors?.required">
                          Valor obrigatório
                        </span>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="line">
                        <div class="label">Valor da taxa<span class="text-danger"> *</span></div>
                        <input formControlName="tax" currencyMask
                          [options]="{ prefix: 'R$', thousands: '.', decimal: ',', precision: 6 }"
                          (blur)="orderFormControl.tax.value < 0 ? orderFormControl.tax.setValue(0) : orderFormControl.tax.value; orderFormControl.tax.value >= 999999 ? orderFormControl.tax.setValue(999999) : orderFormControl.tax.value;"
                          type="text" class="form-control" name="" required />
                        <span class="text-danger"
                          *ngIf="(orderFormControl.tax.touched) && orderFormControl.tax.errors?.required">
                          Valor obrigatório
                        </span>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="line">
                        <div class="label">Imposto de renda<span class="text-danger"> *</span></div>
                        <input formControlName="rate" currencyMask
                          [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                          (blur)="orderFormControl.rate.value < 0 ? orderFormControl.rate.setValue(0) : orderFormControl.rate.value; orderFormControl.rate.value >= 999999 ? orderFormControl.rate.setValue(999999) : orderFormControl.rate.value;"
                          type="text" class="form-control" name="" required />
                        <span class="text-danger"
                          *ngIf="(orderFormControl.rate.touched) && orderFormControl.rate.errors?.required">
                          Valor obrigatório
                        </span>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="line">
                        <div class="label">Alíquota<span class="text-danger"> *</span></div>
                        <input formControlName="aliquot" currencyMask
                          [options]="{ prefix: '', thousands: '.', decimal: ',', suffix: '%' }"
                          (blur)="orderFormControl.aliquot.value < 0 ? orderFormControl.aliquot.setValue(0) : orderFormControl.aliquot.value; orderFormControl.aliquot.value >= 999999 ? orderFormControl.aliquot.setValue(999999) : orderFormControl.aliquot.value;"
                          type="text" class="form-control" name="" required />
                        <span class="text-danger"
                          *ngIf="(orderFormControl.aliquot.touched) && orderFormControl.aliquot.errors?.required">
                          Valor obrigatório
                        </span>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="line">
                        <div class="label">Valor total fechado<span class="text-danger"> *</span></div>
                        <input formControlName="effectiveAmount" currencyMask
                          [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                          (blur)="orderFormControl.effectiveAmount.value < 0 ? orderFormControl.effectiveAmount.setValue(0) : orderFormControl.effectiveAmount.value; orderFormControl.effectiveAmount.value >= 999999 ? orderFormControl.effectiveAmount.setValue(999999) : orderFormControl.effectiveAmount.value;"
                          type="text" class="form-control" name="" required />
                        <span class="text-danger"
                          *ngIf="(orderFormControl.effectiveAmount.touched) && orderFormControl.effectiveAmount.errors?.required">
                          Valor obrigatório
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="dashboard-line-btn">
                <div class="form-row form-invoice">
                  <div class="cols">
                    <div class="form-group mb-0">
                      <button (click)="goBack()" type="button" class="btn-xp-m2 btn-gray-new">
                        Voltar
                      </button>
                    </div>
                  </div>
                  <div class="cols">
                    <div class="form-group mb-0">
                      <button [ngClass]="{'btn-gray-disabled': orderForm.invalid , 'btn-blue-30': !orderForm.invalid}"
                        [disabled]="orderForm.invalid" (click)="save()" type="button" class="btn-xp-m2 btn-blue-30">
                        Conciliar
                        <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
